import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToolsService } from 'src/app/services/tools/tools.service';
import {CssService} from "../../../services/css-service";
import {SalemethodService} from "../../../services/api/salemethod/salemethod.service";

@Component({
  selector: 'app-description-order',
  templateUrl: './description-order.component.html',
  styleUrls: ['./description-order.component.css']
})
export class DescriptionOrderComponent implements OnInit {

  innerHeight: number = window.innerHeight;
  saleMethod: any = this.tools.getStor(SalemethodService.TAG_STORAGE);

  constructor(
    @Inject(MAT_DIALOG_DATA) data:any,
    public dialogRef: MatDialogRef<DescriptionOrderComponent>,
    public cssService: CssService,
    private tools: ToolsService
  ) { }

  ngOnInit() {
    this.tools.setOnPopState(true,'123');
  }

  closeDial() {
    this.dialogRef.close();
  }
}
